export default __webpack_public_path__ + "static/media/IMG_9988.38a3a52c.jpeg";